import { render, staticRenderFns } from "./TwoColumn.vue?vue&type=template&id=0383c4d9&scoped=true"
import script from "./TwoColumn.vue?vue&type=script&lang=js"
export * from "./TwoColumn.vue?vue&type=script&lang=js"
import style0 from "./TwoColumn.vue?vue&type=style&index=0&id=0383c4d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383c4d9",
  null
  
)

export default component.exports